<template>
  <vs-popup
    v-if="popupIsActive"
    :active.sync="popupIsActive"
    class="custom-popup custom-popup--sm"
    @close="$emit('close')"
  >
    <vx-card>
      <div class="vx-card__title mb-4">
        <h2 class="mb-4">Передать оператору</h2>
      </div>
      <div>
        <div class="vs-input--label">Выберите оператора: *</div>
        <SelectInPopup
          label="name"
          v-model="operatorEmail"
          :reduce="option => option.email"
          :options="operators"
        />
        <vs-button
          class="mt-5"
          :disabled="operatorEmail === ''"
          @click.prevent="onShare"
        >
          Передать
        </vs-button>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectInPopup  from '@/components/SelectInPopup.vue'

import Operators from '@/api/http/models/Operators'
import Client from '@/api/http/models/Client'

export default {
  components: {
    SelectInPopup
  },

  data () {
    return {
      popupIsActive: false,
      operators: [],
      operatorEmail: ''
    }
  },

  async created () {
    const response = await Operators.getAll(this.authUserCompany.slug)

    if (response.data) {
      this.operators = response.data.filter(operator => this.authUser.email !== operator.email)
    }
  },

  computed: {
    ...mapGetters(['authUser', 'authUserCompany', 'currentClient'])
  },

  methods: {
    onShare () {
      const send = async () => {
        const response = await Client.transferTo(this.authUserCompany.slug, this.currentClient.client_id, {
          email: this.operatorEmail
        })

        if (response.status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Переписка успешно передана',
            text: ''
          })
          this.$emit('close')
        } else if (response.status === 'not_permitted') {
          this.$vs.notify({
            color: 'danger',
            title: 'Операция недоступна',
            text: ''
          })
        }
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Передать переписку оператору?',
        text: `Переписка будет передана оперетору «${this.operatorEmail}»`,
        accept: send,
        acceptText: 'Отправить',
        cancelText: 'Отменить'
      })
    }
  },

  async mounted () {
    this.popupIsActive = true
  }
}
</script>
